import type { VariantCampaign } from '~/modules/campaign/types';

import { create } from 'zustand';

export interface IVariantStore {
  variants?: VariantCampaign[];
  setVariants: (variants?: VariantCampaign[]) => void;
  getVariants: () => VariantCampaign[] | undefined;
  isFetchedVariants: boolean;
  setIsFetchedVariants: (isFetchedVariants: boolean) => void;
}

export const useVariantStore = create<IVariantStore>()((set, get) => ({
  variants: undefined,
  setVariants: (variants) => set({ variants }),
  getVariants: () => get().variants,
  isFetchedVariants: false,
  setIsFetchedVariants: (isFetchedVariants) => set({ isFetchedVariants }),
}));
